import { render } from "./Backlink.vue?vue&type=template&id=062ae987"
import script from "./Backlink.vue?vue&type=script&lang=js"
export * from "./Backlink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__